import {
  FETCH_PAGINATED_ORDER_PICKUPS,
  FETCH_ALL_ORDER_PICKUPS,
  RESET_ORDER_PICKUPS,
  RESET_CURRENT_ORDER_PICKUP,
  FETCH_ORDER_PICKUPS_TYPES,
  FETCH_CURRENT_ORDER_PICKUP,
  FETCH_ORDER_PICKUPS_EVENTS,
  ORDER_PICKUPS_QUERY,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_ORDER_PICKUPS](state, { orderPickups, pagination }) {
    state.items = orderPickups;
    state.pagination = pagination;
  },

  [FETCH_ALL_ORDER_PICKUPS](state, orderPickups) {
    state.all = orderPickups;
  },

  [RESET_ORDER_PICKUPS](state) {
    state.all = [];
    state.items = [];
    state.types = [];
    state.pagination = {
      currentPage: 1,
      lastPage: 0,
      limit: 5,
      totalCount: 0,
    };
    state.currentOrderPickup = {};
  },

  [RESET_CURRENT_ORDER_PICKUP](state) {
    state.currentOrderPickup = {};
  },

  [FETCH_ORDER_PICKUPS_TYPES](state, orderPickupTypes) {
    state.types = orderPickupTypes;
  },

  [FETCH_CURRENT_ORDER_PICKUP](state, orderPickup) {
    state.currentOrderPickup = orderPickup;
  },

  [FETCH_ORDER_PICKUPS_EVENTS](state, events) {
    state.events = events;
  },

  [ORDER_PICKUPS_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/orderPickup/mutations.js